import React, {Component} from 'react';
import {SanitizeClassNames} from '../common';
import GridView from './GridView';
import moment from 'moment';
import Hammer from 'react-hammerjs';

import './TimeGrid.css';
import GridBox from "../components/gridbox/GridBox";

export default class TimeGrid extends Component {
	state = {};

	constructor(props) {
		super(props);
		this.getRowFromTime = this.getRowFromTime.bind(this);
		this.getTimeFromRow = this.getTimeFromRow.bind(this);

		this.__handleGridItemDrag = this.__handleGridItemDrag.bind(this);
		this.__handleGridItemDrop = this.__handleGridItemDrop.bind(this);
		this.onEmptyCellClick = this.onEmptyCellClick.bind(this);
	}

	newGridData() {
		return {
			w: this.colSegs,
			x: 0,
			y: 1,
			h: 1
		}
	}

	get timeSegs() {
		return this.props.timeSegs || 4;
	}

	get colSegs() {
		return this.props.colSegs || 1;
	}

	get startTime() {
		return this.props.startTime || 8;
	}


	getTimeFromRow = (row) => {
		let incr = 60 / this.timeSegs;
		let hours = this.startTime + parseInt(row / this.timeSegs, 10);
		let mins = (row % this.timeSegs) * incr;
		return moment({hour: hours, minute: mins});
	}

	getRowFromTime = (t) => {
		let time = moment(t);
		let hRow = (time.hour() - this.startTime) * this.timeSegs;
		let mRow = parseInt(time.minute() / (60 / this.timeSegs), 10);
		return hRow + mRow;
	}

	getItems() {
		let items = this.props.items;

		for (let i = 0; i < items.length; i++) {
			let item = items[i];
			let col = item.col || moment(item.timeStart).day();
			let row = this.getRowFromTime(item.timeStart);
			let h = this.getRowFromTime(item.timeEnd) - row;
			item.x = col;
			item.y = row;
			item.w = 1;
			item.h = h;
			item.maxW = 1;
			item.minW = 1;
		}


		return items;
	}

	getBCItems() {
		return [];
	}

	getColumnHeaders() {
		return this.props.columnHeaders || [];
	}

	__getColumnHeaders() {
		let days = [];
		//let cols = (this.state.columnHeaders || []).length;// || this.props.cols || (this.props.colItems || []).length || 7;
		let colItems = this.getColumnHeaders();// this.props.colItems || [];
		this.numHeaders = colItems.length;

		for (let i = 0; i < colItems.length; i++) {
			days.push(colItems[i] || '');
		}

		days = <div className="date-headers table align-center align-middle layout-fixed hmax">
			<div>
				{days}
			</div>
		</div>

		return days;
	}

	getGridItemById(id) {
		return TimeGridItem.__timeGridItems[id];
	}

	__handleGridItemDrag = (item, bounds, itemId, eventName, layer, touchEvent) => {
		//console.log("Item is Dragging")
		//if(oldItem.x != newItem.x || oldItem.y != newItem.y || oldItem.h != newItem.h){
		//let item = this.getGridItemById(newItem.i);
		//item.onMove(newItem);
		//}
	}

	__handleGridItemDrop = (item, bounds, itemId, eventName, layer, touchEvent) => {

	}

	__handleGridItemDragStart = (item, bounds, itemId, eventName, layer, touchEvent) => {
		//let item = this.getGridItemById(newItem.i);
		//item.onStart(newItem);
	}

	__handleGridItemSelect = (item, bounds, itemId, eventName, layer, touchEvent) => {
		switch(layer){
			case 'appointments':
				if(this.props.onAppointmentSelect){
					this.props.onAppointmentSelect(item.appointment);
				}
			break;
			case 'availability':
			case 'unavailable':
				this.onEmptyCellClick(bounds[1], bounds[0]);
			break;
		}


	}

	__handleGridItemDoubleTap = (item, bounds, itemId, eventName, layer, touchEvent) => {

	}

	__handleItemEvent = (item, bounds, itemId, eventName, layer, touchEvent) => {

	}

	onEmptyCellClick = (row, col) => {

	}

	getHeader() {

	}

	hiddenStuff() {

	}

	getClassNames() {
		return '';
	}

	sanitizeClassName(cn) {
		return SanitizeClassNames(this, cn + ' ' + this.getClassNames());
	}

	getScheduleItems(){
		return '';
	}

	render() {

		let time = [];
		let startTime = this.props.startTime;
		let endTime = this.props.endTime;
		let activeStartTime = this.props.activeStartTime || startTime;
		let activeEndTime = this.props.activeEndTime || endTime;
		let totalHours = endTime - startTime;

		let columnHeaders = this.__getColumnHeaders();


		let rows = this.props.rows || totalHours || 12;
		let cols = this.numHeaders || this.props.cols || (this.props.colItems || []).length || 7;

		console.log("Column Headers:", columnHeaders, '  cols:', cols)

		let header = this.getHeader();

		header = (header) ? <div className='time-grid-header'>{header}</div> : '';


		for (let i = 0; i < totalHours; i++) {
			let ampm = ((startTime + i) < 12) ? "AM" : "PM";
			let hours = startTime + i;
			let hour = (startTime + i) % 12;
			let activeClass = (hours >= activeStartTime && hours <= activeEndTime) ? 'active' : 'inActive';
			hour = hour ? hour : 12;
			time.push(<div key={i}>
				<div className={activeClass}><span>{hour} {ampm}</span></div>
			</div>)
		}

		time = <div className='table vmax time-margin align-center hmax'>{time}</div>
		let className = this.props.className || '';
		return (
			<div className={this.sanitizeClassName("time-grid table hmax align-top")}>
				<div>
					<div></div>
					<div>
						{header}
						{columnHeaders}
					</div>
				</div>
				<div>
					<div className="timeContainer">
						<div>{time}</div>
					</div>
					<div className='calendar-grid'>
						<GridBox className="calendar" grid={[cols * this.colSegs, rows * this.timeSegs]}
						         items={
						         	{
						         		'unavailable':{
						         			items: {
						         				'background':{
						         					item: '',
										            className: 'unavailable-time-slots',
										            bounds:[0,0,cols * this.colSegs, rows * this.timeSegs]
									            }
								            }
							            },
						         		'availability':{
						         		    items: this.getScheduleItems(),
								            static: false,
								            className: 'availability-color'
							            },
							            'gridLines': {
						         			items:{},
								            static: true,
								            className: '',
								            lines:([cols , rows])
							            },
						         		'appointments': {
						         			items:this.getItems()
						         		},
							            'bioped-connect':{
											items:this.getBCItems(),
						                    static: false
							            }
						         	}
						         }
						         onTap={this.__handleGridItemSelect}
						         onDoubleTap={this.__handleGridItemDoubleTap}
						         onResize={this.__handleGridItemDrag}
						         onDrag={this.__handleGridItemDrag}
						         onDragStart={this.__handleGridItemDragStart}
						         onDragEnd={this.__handleGridItemDrop}
						         onResizeStart={this.__handleGridItemDragStart}
						         onResizeStop={this.__handleGridItemDrop}/>
						{/*<GridView className="grid-view" cols={cols} rows={rows}>
							<PlainGridCellItem divisions={this.timeSegs} colSegs={this.colSegs}
								onEmptyCellClick={this.onEmptyCellClick}/>
						</GridView>
						<div className="interact-zone">

							<GridBox grid={[cols * this.colSegs, rows * this.timeSegs]} lines={[cols, rows]} mode="react"
								items={this.getItems()}
								onResize={this.__handleGridItemDrag}
								onDrag={this.__handleGridItemDrag}
								onDragStart={this.__handleGridItemDragStart}
								onDragStop={this.__handleGridItemDrop}
								onResizeStart={this.__handleGridItemDragStart}
								onResizeStop={this.__handleGridItemDrop}/>
						</div>*/}
						<CurrentTimeLine start={this.props.startTime} end={this.props.endTime}/>
						{this.hiddenStuff()}
					</div>
				</div>
			</div>
		)
	}
}


class PlainGridCellItem extends Component {

	constructor(props) {
		super(props);
		this.state = {items: this.buildItems()}

	}

	buildItems() {
		let items = [];
		const row = this.props.row;
		const col = this.props.col;
		const div = this.props.divisions || 4;
		for (let i = 0; i < div; i++) {
			items.push(
				<div key={row + col + i}>
					<Hammer onDoubleTap={(e) => {
						e.preventDefault();
						if (this.props.onEmptyCellClick) this.props.onEmptyCellClick((row * div) + i, col * this.props.colSegs);
					}}>
						<div></div>
					</Hammer>
				</div>
			)
		}
		return items;
	}

	render() {
		return (
			<div className="table layout-fixed hmax vmax align-middle align-center add-app-btn">
				{this.state.items}
			</div>
		)
	}
}

class CurrentTimeLine extends Component {
	constructor(props) {
		super(props);
		this.state = {
			style: {
				top: "10%"
			}
		}

		//In Minutes
		this.range = [(this.props.start || 8) * 60, (this.props.end || 20) * 60];
		this.update = this.update.bind(this);
	}

	componentDidMount() {
		this.timerId = setInterval(this.update, 10000);
		this.update();
	}

	update() {
		let mins = this.range[1] - this.range[0];
		let d = new Date();
		let cTime = (d.getHours() * 60) + d.getMinutes();
		let perc = ((cTime - this.range[0]) / mins) * 100;

		this.setState({
			style: {
				top: perc + "%"
			}
		})
	}

	componentWillUnmount() {
		clearInterval(this.timerId);
	}

	render() {
		return (
			<div className="current-time-line" style={this.state.style}>
				<div className="dot"></div>
			</div>
		)
	}
}

export class TimeGridItem extends Component {
	static __timeGridItems = {};
	static __timeGridItemsIndex = 0;

	static GetId() {
		return 'timeGridItem:' + (++TimeGridItem.__timeGridItemsIndex);
	}

	constructor(props) {
		super(props);
		this.__id = this.props.id || TimeGridItem.GetId();
		this.grid = this.props.grid;
	}

	componentDidMount() {
		TimeGridItem.__timeGridItems[this.__id] = this;
	}

	componentWillUnmount() {
		delete TimeGridItem.__timeGridItems[this.__id];
	}

	onMove(pos) {

	}

	onDrop(pos) {

	}

	onStart(pos) {
		//Called when interaction starts
		console.log("Item Start:", pos)
	}

}



// WEBPACK FOOTER //
// ./src/views/TimeGrid.js